import { Feature, FeatureCollection, Geometry } from '@turf/helpers'
import union from '@turf/union'

const ALLOWED_TYPES = ['Polygon', 'MultiPolygon']
/**
 * Given a FeatureCollection, union all Polygon or MultiPolygon Features into a single Polygon | MultiPolygon
 * @param featureCollection FeatureCollection
 * @returns Polygon | MultiPolygon | undefined
 */
export const mergeFeatureCollection = (
  featureCollection: FeatureCollection
): Feature<Geometry> | undefined => {
  if (featureCollection && featureCollection.features) {
    const workingFeatures = featureCollection.features.filter(
      ({ type }) => !ALLOWED_TYPES.includes(type)
    )

    if (workingFeatures.length > 0) {
      let unionFeature = workingFeatures.shift()
      //@ts-ignore unionFeature will exist despite what TS says, we check for length above
      workingFeatures.forEach(feature => (unionFeature = union(unionFeature, feature)))
      return unionFeature as Feature<Geometry> | undefined
    }
  }
}
